import { createSlice } from "@reduxjs/toolkit";

export const searchKeysSlice = createSlice({
  name: "searchKeys",
  initialState: {
    searchKeys: {
      orderId: "",
      serviceName: "",
      ecomProductName: "",
      ecomRating: 0,
      workerName: "",
      workerRating: 0,
      workerLocation: null,
      workerDateTime: null,
      workerNameSmall: "",
      workerRatingSmall: 0,
      workerLocationSmall: null,
      workerDateTimeSmall: null,
      hasFetchedEcommerce: false,
      hasFetchedCleaning: false,
    },
  },
  reducers: {
    setSearchKeys: (state, action) => {
      state.searchKeys = action.payload;
    },
    setHasFetchedEcommerce: (state, action) => {
      state.searchKeys.hasFetchedEcommerce = action.payload;
    },
    setHasFetchedCleaning: (state, action) => {
      state.searchKeys.hasFetchedCleaning = action.payload;
    },
    resetSearchFilter: (state, action) => {
      state.searchKeys.workerName = "";
      state.searchKeys.workerRating = 0;
      state.searchKeys.workerLocation = null;
      state.searchKeys.workerDateTime = null;
      state.searchKeys.hasFetchedEcommerce = false;
      state.searchKeys.hasFetchedCleaning = false;
    },
  },
});

export const {
  setSearchKeys,
  resetSearchFilter,
  setHasFetchedEcommerce,
  setHasFetchedCleaning,
} = searchKeysSlice.actions;

export default searchKeysSlice.reducer;
